import { Component } from '@angular/core';

@Component({
  selector: 'app-results-count',
  imports: [],
  templateUrl: './results-count.component.html',
  styleUrl: './results-count.component.scss'
})
export class ResultsCountComponent {

}
